/*
 * Every add-to-cart form opens the cart drawer instead of loading /cart.
 *
 * The PDP's buy button is a <product-form>, which already does this. The card
 * forms (card-product, ap-formula-card, ap-formula-row, ap-bundle-card,
 * ap-shop-foundation) are plain HTML posts to /cart/add, and Shopify answers a
 * plain post by redirecting to /cart. One delegated listener covers all of
 * them, and any card added later, without touching each snippet.
 *
 * <product-form> and the quiz call preventDefault on their own submit first,
 * so a submit that arrives here already prevented belongs to someone else.
 *
 * A failed add stays on the page with the error beside the button. It never
 * falls back to /cart: that page is what this script exists to avoid.
 */
(function () {
  function isCartAdd(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    try {
      return new URL(form.action, window.location.href).pathname.replace(/\/$/, '').endsWith('/cart/add');
    } catch (e) {
      return false;
    }
  }

  function showError(form, message) {
    let node = form.querySelector('[data-ap-cart-add-error]');
    if (!node) {
      node = document.createElement('p');
      node.className = 'form__message';
      node.setAttribute('role', 'alert');
      node.setAttribute('data-ap-cart-add-error', '');
      form.appendChild(node);
    }
    node.textContent = message;
    node.hidden = false;
  }

  function clearError(form) {
    const node = form.querySelector('[data-ap-cart-add-error]');
    if (node) node.hidden = true;
  }

  document.addEventListener('submit', function (evt) {
    const form = evt.target;
    if (evt.defaultPrevented || !isCartAdd(form)) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    evt.preventDefault();

    const button = evt.submitter || form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return;
    if (button) button.setAttribute('aria-disabled', 'true');
    clearError(form);

    const formData = new FormData(form);
    formData.append(
      'sections',
      drawer.getSectionsToRender().map(function (section) {
        return section.id;
      })
    );
    formData.append('sections_url', window.location.pathname);
    drawer.setActiveElement(button || document.activeElement);

    const errorText = (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          showError(form, state.description || state.message || errorText);
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ap-cart-add', productVariantId: formData.get('id'), cartData: state });
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
      })
      .catch(function () {
        showError(form, errorText);
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-disabled');
      });
  });
})();
